import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Box } from '@material-ui/core';
import colors from './Colors'

const useStyles = (bgColor, borderRadius, border) => makeStyles(theme => ({
    root: {
        display: 'flex',
        border: border || 'none',
        backgroundColor: bgColor || theme.squareButon.bgColor,
        borderRadius: borderRadius || '10px',
        height: 30,
        width: 30,
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        // padding: '6px',
        '&:hover': {
            backgroundColor: bgColor || theme.squareButon.bgColor,
            opacity: 0.5
        },
    }
}));

export default function IconRadiusButton({ children, border, borderRadius, bgColor, ...props }) {
    const classes = useStyles(bgColor, borderRadius, border)()
    return (
        <Box className={classes.root} {...props}>
            {children}
        </Box>
    );
}
